/**
 * 盤面上の一つのセルを表現する
 * 
 * @typedef CellDomain 
 * @export CellDomain
 * @class CellDomain
 */
module.exports= class CellDomain {
    /**
     * Creates an instance of CellDomain.
     * @param {String} komaName セルにある駒名
     * @param {Boolean} isEnemy 相手の駒かどうか
     * @param {Number} index 盤面上のインデックス
     * @memberOf CellDomain
     */
    constructor(komaName='empty',isEnemy,index,boardName){
      this.komaName=komaName;
      this.isEnemy=isEnemy;
      this.isSelf= this.komaName!="empty" && !this.isEnemy;
      this.index=index;
      this.boardName=boardName;
    }
    get row(){
      return Math.floor(this.index/9);
    }
    get column(){
      return this.index-this.row*9;
    }

    clone(){
      return new CellDomain(this.komaName,this.isEnemy,this.index,this.boardName);
    }
}